import { render, staticRenderFns } from "./nr1-dashboard.vue?vue&type=template&id=f7c5f4c4&scoped=true&"
import script from "./nr1-dashboard.vue?vue&type=script&lang=js&"
export * from "./nr1-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./nr1-dashboard.vue?vue&type=style&index=0&id=f7c5f4c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c5f4c4",
  null
  
)

export default component.exports